import { orgBudget, orgBudgetAssignedCostCenters } from './budget.i18n';
import { orgCostCenter, orgCostCenterAssignedBudgets, orgCostCenterBudgets } from './cost-center.i18n';
import { orgPurchaseLimit } from './permission.i18n';
import {
  orgUnit,
  orgUnitAddress,
  orgUnitApprovers,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitAssignedUsers,
  orgUnitChildren,
  orgUnitCostCenters,
  orgUnitUserRoles,
  orgUnitUsers,
} from './units.i18n';
import {
  orgUserGroup,
  orgUserGroupAssignedPermissions,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupUsers,
} from './user-group.i18n';
import {
  orgUser,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserAssignedPermissions,
  orgUserAssignedUserGroups,
  orgUserPermissions,
  orgUserUserGroups,
} from './user.i18n';

export const organization = {
  organization: {
    enabled: 'Actif',
    disabled: 'Désactivé',
    enable: 'Activer',
    disable: 'Désactiver',
    name: 'Nom',
    code: 'Code',
    done: 'terminé',
    cancel: 'Annuler',
    add: 'Ajouter',
    manageUsers: 'Gérer les utilisateurs',
    create: 'Créer {{name}}',
    edit: 'Modifier',
    save: 'Sauvegarder {{name}}',
    delete: 'Supprimer',
    assign: 'Gérer',
    active: 'Actif',
    status: 'Statut',
    details: 'Détails',
    messages: {
      emptyList: 'La liste est vide',
    },
    userRoles: {
      b2bcustomergroup: 'Client',
      b2bapprovergroup: 'Approbateur',
      b2bmanagergroup: 'Gestionnaire',
      b2badmingroup: 'Administrateur',
    },
    userRights: {
      unitorderviewergroup: 'Consulter les commandes au niveau de l\'unité',
    },
    breadcrumb: 'Organisation',
    notification: {
      noSufficientPermissions: 'Droits insuffisants pour accéder à cette page',
      notExist: 'Cet élément n\'existe pas',
      disabled: 'Vous ne pouvez pas modifier un élément désactivé',
    },
    confirmation: {
      cancel: 'ANNULER',
      confirm: 'CONFIRMER',
      disable: 'DÉSACTIVER',
      delete: 'SUPPRIMER',
    },
    httpHandlers: {
      conflict: {
        budget: 'Un budget avec le code {{ code }} existe déjà.',
        costCenter: 'Un centre de coûts avec le code {{ code }} existe déjà.',
        unit: 'Une unité organisationnelle avec l\'UID {{ code }} existe déjà.',
        user: 'Un utilisateur avec le courriel {{ code }} existe déjà',
        userGroup: 'Un groupe d\'utilisateurs avec l\'ID {{ code }} existe déjà',
        permission: 'Une autorisation d\'approbation avec le code {{ code }} existe déjà.',
        unknown: 'Erreur de validation du serveur.',
      },
    },
    information: 'Information',
    staffCustomerTabs: {
      tab: {
        myOrganization: 'Mon organisation',
      },
      search: {
        firstName: 'Nom',
        userType: 'Type d\'utilisateur',
        selectUserType: 'Sélectionner le type d\'utilisateur',
        email: 'Courriel',
        status: 'Statut',
        selectStatus: 'Sélectionner le statut',
      },
      validation: {
        userTypeRequired: 'Le type d\'utilisateur est requis.',
        nameRequired: 'Le nom est requis.',
        descriptionRequired: 'La description est requise.',
        descriptionMaxLength: 'La description ne peut pas dépasser 256 caractères.',
      },
      buttons: {
        clear: 'Effacer',
        search: 'Rechercher',
        addUser: 'Ajouter un utilisateur',
        cancel: 'Annuler',
        update: 'Mettre à jour',
        save: 'Sauvegarder',
        saveCustomer: 'Sauvegarder le client',
        updateStaffMember: 'Mettre à jour le membre du personnel',
        assignStaffMember: 'Assigner un membre du personnel',
        updateCustomer: 'Mettre à jour le client',
      },
      table: {
        name: 'Nom',
        email: 'Courriel',
        roles: 'Rôles',
        status: 'Statut',
        editUserDetails: 'Boutons Modifier',
        actions: 'Actions',
      },
      messages: {
        noStaffUsersFound: 'Aucun utilisateur du personnel trouvé.',
      },
      titles: {
        editUser: 'MODIFIER L\'UTILISATEUR',
        newCustomerForm: 'Nouveau formulaire client',
        assignEditStaffFor: 'Assigner la modification du personnel pour : {{company}}',
        assignNewStaffFor: 'Assigner un nouveau membre du personnel pour : {{company}}',
        editCustomerFor: 'Modifier le client : {{company}}',
        createUser: 'CRÉER UN UTILISATEUR',
      },
      form: {
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Courriel',
        mobileNumber: 'Numéro de mobile',
        jobFunction: 'Fonction',
        roles: 'Rôles',
        customerRole: 'Client',
        managerRole: 'Gestionnaire',
        soldTo: 'Vendu à',
        customerName: 'Nom du compte',
        enterCustomerName: 'Saisir le nom du compte',
        description: 'Description',
        descriptionPlaceholder: 'Description à saisir',
        marginMarkUp: 'Marge / Majoration',
        none: 'Aucun',
        allProducts: 'Tous les produits',
        selectMarginType: 'Sélectionner le type de marge',
        marginValue: 'Valeur de marge',
        enterMarginValue: 'Saisir la valeur de marge',
        markUpValue: 'Valeur de majoration',
        enterMarkUpValue: 'Saisir la valeur de majoration',
        password: 'Mot de passe',
        enterPassword: 'Saisir le mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        confirmPasswordPlaceholder: 'Confirmer le mot de passe',
        selectJobFunction: 'Sélectionner la fonction',
      },
    },
  },
  orgCostCenter,
  orgCostCenterBudgets,
  orgCostCenterAssignedBudgets,
  orgBudget,
  orgBudgetAssignedCostCenters,
  orgUnit,
  orgUnitChildren,
  orgUnitApprovers,
  orgUnitAssignedApprovers,
  orgUnitAssignedRoles,
  orgUnitUsers,
  orgUnitUserRoles,
  orgUnitAssignedUsers,
  orgUnitCostCenters,
  orgUnitAddress,
  orgUserGroup,
  orgUserGroupUsers,
  orgUserGroupAssignedUsers,
  orgUserGroupPermissions,
  orgUserGroupAssignedPermissions,
  orgUser,
  orgUserUserGroups,
  orgUserAssignedUserGroups,
  orgUserApprovers,
  orgUserAssignedApprovers,
  orgUserPermissions,
  orgUserAssignedPermissions,
  orgPurchaseLimit,
};
